import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { FormComponentProps } from '../../AccountForm.meta';
import { TabWrapper } from '../../AccountForm.styles';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { AccountFees } from '../../components/AccountFees/AccountFees';
import { AccountNickname } from '../../components/AccountNickname/AccountNickname';
import { AccountOwnership } from '../../components/AccountOwnership/AccountOwnership';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { AssetBucketing } from '../../components/AssetBucketing/AssetBucketing';
import { Balance } from '../../components/Balance/Balance';
import { BrokerOfRecord } from '../../components/BrokerOfRecord/BrokerOfRecord';
import { ContributionEndYearSelect } from '../../components/ContributionEndYearSelect/ContributionEndYearSelect';
import { ContributionStartYearSelect } from '../../components/ContributionStartYearSelect/ContributionStartYearSelect';
import { Contributions } from '../../components/Contributions/Contributions';
import { DistributionStrategySelect } from '../../components/DistributionStrategy/DistributionStrategySelect';
import { EmployerContribution } from '../../components/EmployerContribution/EmployerContribution';
import { GrossEstateCheckbox } from '../../components/GrossEstateCheckbox/GrossEstateCheckbox';
import { InstitutionNameInput } from '../../components/InstitutionNameInput/InstitutionNameInput';
import { ManagementStyle } from '../../components/ManagementStyle/ManagementStyle';
import { TabsContent } from '../../components/TabsContent/TabsContent';

const Summary = () => {
  return (
    <TabWrapper>
      <AccountTypeSelect />
      <InstitutionNameInput />
      <AccountOwnership />
      <AccountDescription />
      <AccountNickname />
      <Balance label="Current Market Value" />
      <Contributions label="Owner Contribution" />
      <EmployerContribution />
      <GrossEstateCheckbox />
      <BrokerOfRecord />
      <ManagementStyle />
      <AssetBucketing />
    </TabWrapper>
  );
};

const AccountDetails = () => {
  return (
    <TabWrapper>
      <Box
        css={`
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        `}
      >
        <ContributionStartYearSelect />
        <ContributionEndYearSelect />
      </Box>

      <DistributionStrategySelect />
      <AccountFees />
    </TabWrapper>
  );
};

export const HSA = (props: FormComponentProps) => {
  return (
    <TabsContent
      {...props}
      tabs={[
        { name: 'Summary', Component: Summary },
        { name: 'Details', Component: AccountDetails },
      ]}
    />
  );
};
